<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card">
					<div class="card-header bg-info text-white">
						Selecciona imagen
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div class="card-body" style="position:relative;display:block;">
						<vue-cropper @img="setImg($event)"></vue-cropper>
					</div>

					<div class="card-footer">
						<button class="btn btn-sm btn-primary" @click="confirmar()" v-if="url">Aceptar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	name: 'set-avatar',

	data: function () {
		return {
			url: null
		}
	},

	methods: {

		setImg (url) {
			this.url = url
		},

		confirmar () {
			this.$emit('img', this.url)
			this.cerrar()
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/core/vue/components/mi-perfil/crop-avatar.vue